(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const syncResponsiveDisclosures = () => {
    document.querySelectorAll('[data-neuma-responsive-disclosure]').forEach((disclosure) => {
      if (mobileQuery.matches) {
        disclosure.removeAttribute('open');
      } else {
        disclosure.setAttribute('open', '');
      }
    });
  };

  const setFinderMode = (form, mode) => {
    form.dataset.neumaFinderMode = mode;
    form.querySelectorAll('[data-neuma-finder-tab]').forEach((tab) => {
      const active = tab.dataset.neumaFinderTab === mode;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    form.querySelectorAll('[data-neuma-finder-panel]').forEach((panel) => {
      const active = panel.dataset.neumaFinderPanel === mode;
      panel.hidden = !active;
      panel.querySelectorAll('select, input').forEach((field) => {
        // Los hidden (filtros de medida del panel vehículo) los enciende solo
        // su lógica justo antes de enviar; al activar la pestaña no se tocan.
        if (active && field.type === 'hidden') return;
        field.disabled = !active;
      });
    });
  };

  const setProductTab = (tab) => {
    const tabs = tab.closest('[role="tablist"]');
    const root = tabs && tabs.parentElement;
    if (!tabs || !root) return;
    const key = tab.dataset.neumaProductTab;
    tabs.querySelectorAll('[data-neuma-product-tab]').forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', active ? 'true' : 'false');
      item.tabIndex = active ? 0 : -1;
    });
    root.querySelectorAll('[data-neuma-product-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.neumaProductPanel !== key;
    });
  };

  const initMegaMenus = () => {
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-neuma-mega]').forEach((menu) => {
      menu.addEventListener('pointerenter', () => menu.setAttribute('open', ''));
      menu.addEventListener('pointerleave', () => {
        if (!menu.matches(':focus-within')) menu.removeAttribute('open');
      });
      menu.addEventListener('focusout', (event) => {
        if (!menu.contains(event.relatedTarget)) menu.removeAttribute('open');
      });
    });
  };

  syncResponsiveDisclosures();
  mobileQuery.addEventListener?.('change', syncResponsiveDisclosures);
  initMegaMenus();

  document.addEventListener('click', (event) => {
    const finderTab = event.target.closest('[data-neuma-finder-tab]');
    if (finderTab) {
      const form = finderTab.closest('[data-neuma-finder]');
      if (form) setFinderMode(form, finderTab.dataset.neumaFinderTab);
      return;
    }

    const filterMore = event.target.closest('[data-neuma-filter-more]');
    if (filterMore) {
      const values = filterMore.closest('[data-neuma-filter-values]');
      const expanded = filterMore.getAttribute('aria-expanded') === 'true';
      values?.querySelectorAll('[data-neuma-filter-extra]').forEach((item) => { item.hidden = expanded; });
      filterMore.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      filterMore.textContent = expanded ? 'Ver más' : 'Ver menos';
      return;
    }

    const productTab = event.target.closest('[data-neuma-product-tab]');
    if (productTab) {
      setProductTab(productTab);
      return;
    }

    const thumbnail = event.target.closest('[data-neuma-product-media]');
    if (thumbnail) {
      const gallery = thumbnail.closest('[data-neuma-gallery]');
      const image = gallery?.querySelector('[data-neuma-main-media] img');
      if (!image) return;
      image.src = thumbnail.dataset.src;
      image.removeAttribute('srcset');
      image.alt = thumbnail.dataset.alt || '';
      gallery.querySelectorAll('[data-neuma-product-media]').forEach((item) => item.setAttribute('aria-pressed', item === thumbnail ? 'true' : 'false'));
      return;
    }

    const mobileNavLink = event.target.closest('[data-neuma-mobile-menu] a');
    if (mobileNavLink) mobileNavLink.closest('[data-neuma-mobile-menu]')?.removeAttribute('open');

    document.querySelectorAll('[data-neuma-mobile-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    const finderTab = event.target.closest?.('[data-neuma-finder-tab]');
    if (finderTab && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
      const tabs = [...finderTab.closest('[role="tablist"]').querySelectorAll('[data-neuma-finder-tab]')];
      const index = tabs.indexOf(finderTab);
      tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length]?.focus();
      event.preventDefault();
      return;
    }
    const productTab = event.target.closest?.('[data-neuma-product-tab]');
    if (productTab && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
      const tabs = [...productTab.closest('[role="tablist"]').querySelectorAll('[data-neuma-product-tab]')];
      const index = tabs.indexOf(productTab);
      const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      next.focus();
      setProductTab(next);
      event.preventDefault();
      return;
    }
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-neuma-mobile-menu][open]').forEach((menu) => {
        menu.removeAttribute('open');
        menu.querySelector('summary')?.focus();
      });
      document.querySelectorAll('[data-neuma-mega][open]').forEach((menu) => menu.removeAttribute('open'));
    }
  });

  // --- Sub-filtrado en cascada del buscador por dimensión -------------------
  // El filtrado en vivo de la colección hace morph de la sección y puede
  // reemplazar el contenedor, así que se delega en document: ningún re-render
  // deja la cascada sin escuchar.
  const cascadeSeq = new WeakMap();

  const rebuildCascadeSelect = (select, values) => {
    const chosen = select.value;
    select.textContent = '';
    select.append(new Option('Elegir', ''));
    values.forEach((value) => select.append(new Option(value.label, value.value)));
    select.value = chosen;
    if (select.value !== chosen) select.value = '';
    // Sin valores posibles la medida no aplica: un select con sólo "Elegir" confunde.
    select.disabled = values.length === 0;
  };

  const refreshCascade = async (fields) => {
    const form = fields.closest('form');
    const selects = [...fields.querySelectorAll('select')];
    if (!form || !selects.length) return;
    const seq = (cascadeSeq.get(fields) || 0) + 1;
    cascadeSeq.set(fields, seq);

    const params = new URLSearchParams({ section_id: 'neuma-finder-facets' });
    // El form ya trae disponibilidad y los filtros conservados de la barra
    // lateral, así las opciones reflejan lo que realmente va a devolver.
    new FormData(form).forEach((value, key) => { if (value) params.append(key, value); });
    try {
      const res = await fetch(`${form.action}?${params}`);
      const text = await res.text();
      // La respuesta viene envuelta en el div de sección de Shopify: extraer el JSON.
      const { filters } = JSON.parse(text.slice(text.indexOf('{'), text.lastIndexOf('}') + 1));
      if (cascadeSeq.get(fields) !== seq) return;
      selects.forEach((select) => {
        if (filters[select.name]) rebuildCascadeSelect(select, filters[select.name]);
      });
    } catch {
      // ponytail: si falla la red se mantienen las opciones actuales; el filtro final lo aplica igual la colección.
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.tagName !== 'SELECT') return;
    const fields = event.target.closest('[data-neuma-cascade]');
    if (fields) refreshCascade(fields);
  });

  // En una colección ya filtrada, Shopify colapsa las listas a los valores
  // vigentes; una pasada inicial marca como no aplicables las que quedan vacías.
  document.querySelectorAll('[data-neuma-cascade]').forEach((fields) => {
    if ([...fields.querySelectorAll('select')].some((select) => select.value)) refreshCascade(fields);
  });

  // --- Selección de instalación y cotización de despacho (carrito) ---------
  const install = document.querySelector('[data-neuma-install]');
  if (install) {
    const quoteEl = install.querySelector('[data-neuma-quote]');
    const regionSel = install.querySelector('[data-neuma-region]');
    const comunaSel = install.querySelector('[data-neuma-comuna]');
    const attrs = {
      modo: install.querySelector('[data-neuma-attr-modo]'),
      taller: install.querySelector('[data-neuma-attr-taller]'),
      comuna: install.querySelector('[data-neuma-attr-comuna]'),
      despacho: install.querySelector('[data-neuma-attr-despacho]'),
    };
    const clp = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' });
    let comunas = null;
    let quoteSeq = 0;

    const loadComunas = async () => {
      if (comunas || !regionSel) return;
      const res = await fetch(install.dataset.neumaComunasUrl);
      comunas = await res.json();
      regionSel.innerHTML = '<option value="">Selecciona tu región</option>' +
        Object.keys(comunas).map((r) => `<option value="${r}">${r}</option>`).join('');
    };

    const setMode = (mode) => {
      install.querySelectorAll('[data-neuma-install-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.neumaInstallPanel !== mode;
      });
      attrs.modo.value = mode === 'taller' ? 'Taller asociado' : 'Despacho a domicilio';
      if (mode === 'taller') {
        attrs.comuna.value = '';
        attrs.despacho.value = '';
      } else {
        attrs.taller.value = '';
        loadComunas();
      }
    };

    const cotizar = async (comuna) => {
      const seq = ++quoteSeq;
      quoteEl.textContent = 'Cotizando despacho…';
      attrs.despacho.value = '';
      try {
        const res = await fetch(install.dataset.neumaQuoteUrl, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ comuna, gramos: Number(install.dataset.neumaCartGrams) }),
        });
        const json = await res.json();
        if (seq !== quoteSeq) return;
        if (json.ok) {
          quoteEl.textContent = `Despacho estimado a ${comuna}: ${clp.format(json.importe)} (IVA incluido).`;
          attrs.despacho.value = clp.format(json.importe);
        } else {
          quoteEl.textContent = json.message || 'Cotización no disponible.';
        }
      } catch {
        if (seq === quoteSeq) quoteEl.textContent = 'No pudimos cotizar el despacho. Intenta nuevamente.';
      }
    };

    install.addEventListener('change', (event) => {
      const mode = event.target.closest('[data-neuma-install-mode]');
      if (mode) return setMode(mode.value);

      if (event.target.closest('[data-neuma-taller]')) {
        attrs.taller.value = event.target.value;
        return;
      }

      if (event.target === regionSel) {
        const list = (comunas && comunas[regionSel.value]) || [];
        comunaSel.disabled = list.length === 0;
        comunaSel.innerHTML = '<option value="">Selecciona tu comuna</option>' +
          list.map((c) => `<option value="${c}">${c}</option>`).join('');
        quoteEl.textContent = 'Selecciona región y comuna para cotizar el despacho.';
        attrs.comuna.value = '';
        attrs.despacho.value = '';
        return;
      }

      if (event.target === comunaSel && comunaSel.value) {
        attrs.comuna.value = comunaSel.value;
        cotizar(comunaSel.value);
      }
    });
  }

  // --- Boleta / factura en el carrito ---------------------------------------
  const doc = document.querySelector('[data-neuma-doc]');
  if (doc) {
    const panel = doc.querySelector('[data-neuma-doc-panel]');
    // RUT siempre visible y obligatorio (boleta y factura); razón social y giro solo con factura.
    const rutInput = doc.querySelector('[data-neuma-rut]');
    const rutLabel = doc.querySelector('[data-neuma-rut-label]');
    const inputs = [...doc.querySelectorAll('[data-neuma-doc-input]')];
    const [razonInput, giroInput] = inputs;

    // Se acepta el RUT con o sin puntos/guion, con guiones raros del
    // autocorrector o caracteres invisibles: solo cuentan dígitos y K, y el
    // último es el verificador (módulo 11).
    const partesRut = (valor) => {
      const m = String(valor).toUpperCase().replace(/[^0-9K]/g, '').match(/^(\d{7,8})([\dK])$/);
      return m ? { numero: m[1], dv: m[2] } : null;
    };
    const rutValido = (valor) => {
      const p = partesRut(valor);
      if (!p) return false;
      let suma = 0;
      let mult = 2;
      for (let i = p.numero.length - 1; i >= 0; i--) {
        suma += Number(p.numero[i]) * mult;
        mult = mult === 7 ? 2 : mult + 1;
      }
      const resto = 11 - (suma % 11);
      return p.dv === (resto === 11 ? '0' : resto === 10 ? 'K' : String(resto));
    };
    // Muestra 10.970.668-K (con puntos y guion normal); Hermes recibe el
    // formato sin puntos, lo normaliza el worker.
    const formatearRut = (valor) => {
      const p = partesRut(valor);
      return p ? `${p.numero.replace(/\B(?=(\d{3})+$)/g, '.')}-${p.dv}` : valor;
    };

    const esFactura = () => doc.querySelector('[data-neuma-doc-mode]:checked')?.value === 'Factura';

    const setModo = (factura) => {
      panel.hidden = !factura;
      inputs.forEach((input) => { input.disabled = !factura; input.setCustomValidity(''); });
      rutInput.setCustomValidity('');
      if (rutLabel) rutLabel.textContent = factura ? 'RUT de la empresa' : 'RUT';
    };

    doc.addEventListener('change', (event) => {
      if (event.target.closest('[data-neuma-doc-mode]')) setModo(esFactura());
    });

    // La K del verificador siempre en mayúscula, ya mientras se escribe.
    rutInput?.addEventListener('input', () => {
      if (!/k/.test(rutInput.value)) return;
      const pos = rutInput.selectionStart;
      rutInput.value = rutInput.value.toUpperCase();
      rutInput.setSelectionRange(pos, pos);
    });

    rutInput?.addEventListener('blur', () => {
      if (!rutInput.value.trim()) return;
      rutInput.value = formatearRut(rutInput.value);
    });

    // Bloquea "Continuar al pago" sin RUT válido (boleta o factura) o, con
    // factura, sin razón social/giro. "Actualizar carrito" pasa siempre.
    document.addEventListener('submit', (event) => {
      const form = event.target.closest('.neuma-cart-form');
      if (!form || event.submitter?.name !== 'checkout') return;
      let invalido = null;
      rutInput.value = formatearRut(rutInput.value.trim());
      if (!rutValido(rutInput.value)) invalido = rutInput;
      else if (esFactura() && !razonInput.value.trim()) invalido = razonInput;
      else if (esFactura() && !giroInput.value.trim()) invalido = giroInput;
      if (!invalido) return;
      invalido.setCustomValidity(invalido === rutInput ? 'Ingresa un RUT válido, por ejemplo 12.345.678-9.' : 'Este campo es obligatorio para la factura.');
      event.preventDefault();
      event.stopImmediatePropagation();
      invalido.reportValidity();
      invalido.focus();
    });

    setModo(esFactura());
  }

  // --- Productos relacionados: misma medida, o ninguno -----------------------
  // La sección viene oculta desde el servidor (Liquid no puede filtrar por
  // metacampo). Acá se piden los de la medida exacta y solo entonces se
  // muestra. Sin coincidencias no se muestra nada: mostrar otra medida sería
  // ofrecerle al comprador un neumático que no le sirve.
  {
    const bloque = document.querySelector('[data-neuma-related]');
    const grid = bloque?.querySelector('[data-neuma-related-grid]');
    // Ojo: data-neuma-ancho llega al dataset como neumaAncho.
    const { neumaAncho: ancho, neumaPerfil: perfil, neumaAro: aro, neumaProductId: productId, neumaRelatedUrl: relatedUrl } = bloque?.dataset ?? {};
    // Los filtros guardan decimales ("205.0"); el dato del producto no siempre.
    const decimal = (v) => (v && !v.includes('.') ? `${v}.0` : v);

    if (grid && ancho && aro) {
      const params = new URLSearchParams({ section_id: 'neuma-related-grid', 'filter.v.availability': '1' });
      params.append('filter.p.m.custom.ancho', decimal(ancho));
      // Hay medidas sin perfil (6.00R13): ahí la medida exacta es ancho + aro.
      if (perfil) params.append('filter.p.m.custom.perfil', decimal(perfil));
      params.append('filter.p.m.custom.aro', aro);

      fetch(`${relatedUrl}?${params}`)
        .then((res) => (res.ok ? res.text() : Promise.reject(new Error(String(res.status)))))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const cards = [...doc.querySelectorAll('.neuma-product-card')]
            .filter((card) => card.dataset.neumaProductId !== productId)
            .slice(0, 4);
          if (!cards.length) return;
          grid.replaceChildren(...cards);
          bloque.hidden = false;
          marcarCompatibles();
        })
        .catch(() => {});
    }
  }

  // --- Pregunta sobre el producto: enviar sin salir de la página --------------
  // Shopify responde al /contact con una redirección a la misma página; acá se
  // envía por fetch y se reemplaza el formulario por el agradecimiento. Si
  // Shopify pide el captcha (/challenge) se deja seguir al envío normal.
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-neuma-pregunta]');
    if (!form || form.dataset.neumaEnviado) return;
    event.preventDefault();
    const boton = form.querySelector('button[type="submit"]');
    boton.disabled = true;
    try {
      const res = await fetch(form.action, { method: 'POST', body: new FormData(form), redirect: 'follow' });
      if (res.url.includes('/challenge')) { form.dataset.neumaEnviado = '1'; form.submit(); return; }
      if (!res.ok) throw new Error(String(res.status));
      form.innerHTML = '<p class="neuma-contact-form__gracias" role="status">¡Gracias! Recibimos tu pregunta y te respondemos por correo.</p>';
    } catch {
      boton.disabled = false;
      form.dataset.neumaEnviado = '1';
      form.submit();
    }
  });

  // --- Cantidades del carrito: actualizar solo ------------------------------
  // El formulario nativo del carrito exige apretar "Actualizar carrito" para
  // recalcular el total. Se envía solo al cambiar la cantidad y el botón se
  // esconde acá (no en CSS) para que siga estando cuando no hay JS, que es el
  // único caso en que hace falta.
  //
  // Todo cambio (teclear, flechas del campo, blur) reinicia una espera de 1 s:
  // subir de 1 a 5 a golpes rápidos manda un solo envío con el 5, no cinco.
  {
    const ESPERA_MS = 1000;
    let pendiente = null;
    document.querySelectorAll('.neuma-cart-form button[name="update"]').forEach((boton) => { boton.hidden = true; });

    const enviar = (input) => {
      const form = input.closest('.neuma-cart-form');
      if (!form || form.dataset.neumaEnviando) return;
      const boton = form.querySelector('button[name="update"]');
      if (!boton) return;
      form.dataset.neumaEnviando = '1';
      input.disabled = false;
      if (form.requestSubmit) form.requestSubmit(boton); else boton.click();
    };

    // Barra de espera arriba: la misma que usa la navegación, con una animación
    // que dura lo que el temporizador. Se recrea en cada cambio, y recrearla es
    // justamente lo que reinicia la animación desde cero.
    let barraEspera = null;
    const mostrarEspera = () => {
      barraEspera?.remove();
      barraEspera = document.createElement('div');
      barraEspera.className = 'neuma-progress neuma-progress--espera';
      barraEspera.style.setProperty('--neuma-espera', `${ESPERA_MS}ms`);
      document.body.appendChild(barraEspera);
    };
    const ocultarEspera = () => {
      barraEspera?.remove();
      barraEspera = null;
    };

    const programar = (event) => {
      const input = event.target.closest('.neuma-cart-form input[name="updates[]"]');
      if (!input) return;
      clearTimeout(pendiente);
      mostrarEspera();
      pendiente = setTimeout(() => {
        // Se revalida al disparar: en 1 s el campo pudo quedar vacío o inválido.
        ocultarEspera();
        if (input.isConnected && input.value.trim() !== '' && input.checkValidity()) enviar(input);
      }, ESPERA_MS);
    };
    document.addEventListener('input', programar);
    document.addEventListener('change', programar);
  }

  // --- Buscador por vehículo -------------------------------------------------
  // Los selects de marca/modelo/año/versión no tienen name (no viajan en la
  // URL); solo alimentan la cascada contra los JSON estáticos de
  // assets/neuma-vehiculos*.json y calculan la medida a filtrar. Delegado en
  // document porque el filtrado en vivo de la colección puede reemplazar DOM.
  const VEH_KEY = 'neuma:vehiculo';

  const leerVehiculo = () => {
    try {
      const raw = localStorage.getItem(VEH_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const guardarVehiculo = (veh) => {
    try {
      localStorage.setItem(VEH_KEY, JSON.stringify(veh));
    } catch {
      // ponytail: sin storage el buscador funciona igual, solo no recuerda entre visitas.
    }
  };

  const borrarVehiculo = () => {
    try {
      localStorage.removeItem(VEH_KEY);
    } catch {
      // ver comentario de guardarVehiculo
    }
  };

  let vehIndicePromise = null;
  const cargarVehIndice = (url) => {
    if (!vehIndicePromise) vehIndicePromise = fetch(url).then((res) => res.json());
    return vehIndicePromise;
  };

  const vehMarcaCache = new Map();
  const cargarVehMarca = (indiceUrl, generado, slug) => {
    if (!vehMarcaCache.has(slug)) {
      const url = `${indiceUrl.replace('neuma-vehiculos.json', `neuma-vehiculos-${slug}.json`).replace(/\?.*/, '')}?v=${generado}`;
      vehMarcaCache.set(slug, fetch(url).then((res) => res.json()));
    }
    return vehMarcaCache.get(slug);
  };

  const vehFields = (panel) => ({
    marca: panel.querySelector('[data-neuma-veh-marca]'),
    modelo: panel.querySelector('[data-neuma-veh-modelo]'),
    anio: panel.querySelector('[data-neuma-veh-anio]'),
    version: panel.querySelector('[data-neuma-veh-version]'),
    resultado: panel.querySelector('[data-neuma-veh-resultado]'),
    medidas: panel.querySelector('[data-neuma-veh-medidas]'),
    aviso: panel.querySelector('[data-neuma-veh-aviso]'),
    ancho: panel.querySelector('[data-neuma-veh-ancho]'),
    perfil: panel.querySelector('[data-neuma-veh-perfil]'),
    aro: panel.querySelector('[data-neuma-veh-aro]'),
    q: panel.querySelector('[data-neuma-veh-q]'),
    guardado: panel.querySelector('[data-neuma-veh-guardado]'),
    titulo: panel.querySelector('[data-neuma-veh-titulo]'),
    subtitulo: panel.querySelector('[data-neuma-veh-subtitulo]'),
    guardadoMedidas: panel.querySelector('[data-neuma-veh-guardado-medidas]'),
  });

  const resetVehSelect = (select) => {
    select.textContent = '';
    select.append(new Option('Elegir', ''));
    select.disabled = true;
  };

  const fillVehSelect = (select, opciones) => {
    select.textContent = '';
    select.append(new Option('Elegir', ''));
    opciones.forEach((o) => select.append(new Option(o.label, o.value)));
    select.disabled = false;
  };

  const limpiarFiltrosVeh = (f) => {
    [f.ancho, f.perfil, f.aro, f.q].forEach((input) => { input.disabled = true; input.value = ''; });
  };

  const MEDIDA_COMPLETA = /^(\d{3})\/(\d{2,3})Z?R(\d{2})(C|LT)?$/;
  const MEDIDA_SIMPLE = /^(\d{3})R(\d{2})(C|LT)?$/;

  // Traduce una medida ("205/55R16") a los filtros nativos de Shopify. El
  // formato exacto importa: ancho/perfil llevan ".0" y el aro va entero.
  const aplicarMedidaAFiltros = (f, medida) => {
    limpiarFiltrosVeh(f);
    const texto = String(medida).toUpperCase().trim();
    let m = texto.match(MEDIDA_COMPLETA);
    if (m) {
      f.ancho.disabled = false; f.ancho.value = `${Number(m[1])}.0`;
      f.perfil.disabled = false; f.perfil.value = `${Number(m[2])}.0`;
      f.aro.disabled = false; f.aro.value = String(Number(m[3]));
      return;
    }
    m = texto.match(MEDIDA_SIMPLE);
    if (m) {
      f.ancho.disabled = false; f.ancho.value = `${Number(m[1])}.0`;
      f.aro.disabled = false; f.aro.value = String(Number(m[2]));
      return;
    }
    // Ninguna medida calzó con el patrón: cae al buscador de texto libre.
    f.q.disabled = false; f.q.value = texto;
  };

  // breve = la medida ya se lee arriba (tarjeta del vehículo guardado); repetirla
  // en el botón sobra.
  const pintarMedidas = (contenedor, del, tras, onElegir, breve) => {
    contenedor.textContent = '';
    const boton = (texto, medida) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'neuma-button neuma-button--secondary';
      btn.textContent = texto;
      btn.addEventListener('click', () => onElegir(medida));
      return btn;
    };
    if (del === tras) {
      contenedor.append(boton(breve ? 'Buscar neumáticos' : `Buscar ${del}`, del));
    } else {
      contenedor.append(
        boton(breve ? 'Buscar delanteros' : `Delanteros ${del}`, del),
        boton(breve ? 'Buscar traseros' : `Traseros ${tras}`, tras)
      );
    }
  };

  const enviarVeh = (panel, f, medida) => {
    aplicarMedidaAFiltros(f, medida);
    const form = panel.closest('form');
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  };

  const mostrarResultadoVeh = (panel, f, datos) => {
    f.resultado.hidden = false;
    f.aviso.hidden = datos.conf !== 'M';
    pintarMedidas(f.medidas, datos.del, datos.tras, (medida) => {
      guardarVehiculo({
        marca: datos.marca || '',
        modelo: datos.modelo,
        anio: datos.anio,
        version: datos.version,
        del: datos.del,
        tras: datos.tras,
        conf: datos.conf,
        guardadoEn: Date.now(),
      });
      enviarVeh(panel, f, medida);
    });
  };

  const vehFilas = new WeakMap();

  // Cascada en el orden de la tabla de Movsa: marca → año → modelo → versión.
  // El JSON de cada marca viene como modelo → año → versiones; acá se recorre
  // al revés para ofrecer primero los años y después los modelos de ese año.
  const onVehMarcaChange = async (select) => {
    const panel = select.closest('[data-neuma-finder-panel="vehiculo"]');
    const f = vehFields(panel);
    resetVehSelect(f.anio);
    resetVehSelect(f.modelo);
    resetVehSelect(f.version);
    f.resultado.hidden = true;
    f.aviso.hidden = true;
    limpiarFiltrosVeh(f);
    const slug = select.value;
    if (!slug) return;
    const indice = await cargarVehIndice(panel.dataset.neumaVehiculos);
    const datos = await cargarVehMarca(panel.dataset.neumaVehiculos, indice.generado, slug);
    const anios = [...new Set(Object.values(datos).flatMap((porAnio) => Object.keys(porAnio)))].sort((a, b) => b - a);
    fillVehSelect(f.anio, anios.map((anio) => ({ value: anio, label: anio })));
  };

  const onVehAnioChange = async (select) => {
    const panel = select.closest('[data-neuma-finder-panel="vehiculo"]');
    const f = vehFields(panel);
    resetVehSelect(f.modelo);
    resetVehSelect(f.version);
    f.resultado.hidden = true;
    f.aviso.hidden = true;
    limpiarFiltrosVeh(f);
    const anio = select.value;
    if (!anio || !f.marca.value) return;
    const indice = await cargarVehIndice(panel.dataset.neumaVehiculos);
    const datos = await cargarVehMarca(panel.dataset.neumaVehiculos, indice.generado, f.marca.value);
    const modelos = Object.keys(datos).filter((modelo) => datos[modelo][anio]).sort((a, b) => a.localeCompare(b, 'es'));
    fillVehSelect(f.modelo, modelos.map((modelo) => ({ value: modelo, label: modelo })));
  };

  const onVehModeloChange = async (select) => {
    const panel = select.closest('[data-neuma-finder-panel="vehiculo"]');
    const f = vehFields(panel);
    resetVehSelect(f.version);
    f.resultado.hidden = true;
    f.aviso.hidden = true;
    limpiarFiltrosVeh(f);
    const modelo = select.value;
    if (!modelo || !f.marca.value || !f.anio.value) return;
    const indice = await cargarVehIndice(panel.dataset.neumaVehiculos);
    const datos = await cargarVehMarca(panel.dataset.neumaVehiculos, indice.generado, f.marca.value);
    const filas = (datos[modelo] || {})[f.anio.value] || [];
    vehFilas.set(panel, filas);
    if (!filas.length) return;
    fillVehSelect(f.version, filas.map((fila, i) => ({ value: String(i), label: fila[0] || 'Versión única' })));
    // Con una sola versión no hay nada que elegir: se marca y se muestra la medida.
    if (filas.length === 1) {
      f.version.value = '0';
      onVehVersionChange(f.version);
    }
  };

  const onVehVersionChange = (select) => {
    const panel = select.closest('[data-neuma-finder-panel="vehiculo"]');
    const f = vehFields(panel);
    f.resultado.hidden = true;
    f.aviso.hidden = true;
    limpiarFiltrosVeh(f);
    const idx = select.value;
    if (idx === '') return;
    const fila = (vehFilas.get(panel) || [])[Number(idx)];
    if (!fila) return;
    const [version, del, tras, conf] = fila;
    const marcaLabel = f.marca.selectedOptions[0]?.text || '';
    mostrarResultadoVeh(panel, f, { marca: marcaLabel, modelo: f.modelo.value, anio: f.anio.value, version, del, tras, conf });
  };

  document.addEventListener('change', (event) => {
    const marcaSel = event.target.closest('[data-neuma-veh-marca]');
    if (marcaSel) return onVehMarcaChange(marcaSel);
    const modeloSel = event.target.closest('[data-neuma-veh-modelo]');
    if (modeloSel) return onVehModeloChange(modeloSel);
    const anioSel = event.target.closest('[data-neuma-veh-anio]');
    if (anioSel) return onVehAnioChange(anioSel);
    const versionSel = event.target.closest('[data-neuma-veh-version]');
    if (versionSel) return onVehVersionChange(versionSel);
  });

  const normalizaMedida = (medida) => String(medida || '').replace(/\s+/g, '').toUpperCase();

  const mostrarGuardadoVeh = (panel, veh) => {
    const f = vehFields(panel);
    panel.querySelector('.neuma-fields').hidden = true;
    f.resultado.hidden = true;
    f.guardado.hidden = false;
    f.titulo.textContent = `${[veh.marca, veh.modelo, veh.version].filter(Boolean).join(' ')} · ${veh.anio}`;
    f.subtitulo.textContent = veh.del === veh.tras ? `Medida ${veh.del}` : `Delanteros ${veh.del} · Traseros ${veh.tras}`;
    pintarMedidas(f.guardadoMedidas, veh.del, veh.tras, (medida) => enviarVeh(panel, f, medida), true);
  };

  const initVehPanel = async (panel) => {
    const f = vehFields(panel);
    const indice = await cargarVehIndice(panel.dataset.neumaVehiculos);
    fillVehSelect(f.marca, indice.marcas.map((marca) => ({ value: marca.slug, label: marca.nombre })));
    return indice;
  };

  // El índice (18 KB) se pide al primer clic en la pestaña, no en cada carga
  // de página: la mayoría busca por dimensión y no lo necesita.
  const vehPanelesIniciados = new WeakSet();
  // Idempotente: lo llaman la pestaña y "Cambiar vehículo"; el que llegue
  // primero puebla el select de marcas, el resto solo recibe el índice.
  const asegurarVehPanel = (panel) => {
    if (vehPanelesIniciados.has(panel)) return cargarVehIndice(panel.dataset.neumaVehiculos);
    vehPanelesIniciados.add(panel);
    return initVehPanel(panel);
  };
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-neuma-finder-tab="vehiculo"]');
    if (!tab) return;
    const panel = tab.closest('[data-neuma-finder]')?.querySelector('[data-neuma-finder-panel="vehiculo"]');
    if (!panel) return;
    asegurarVehPanel(panel).catch(() => {
      // ponytail: si el índice no carga el panel queda con solo "Elegir"; la pestaña de dimensión sigue funcionando.
    });
  });

  const vehGuardadoInicial = leerVehiculo();
  if (vehGuardadoInicial) {
    document.querySelectorAll('[data-neuma-finder]').forEach((form) => {
      const panel = form.querySelector('[data-neuma-finder-panel="vehiculo"]');
      if (!panel) return;
      setFinderMode(form, 'vehiculo');
      mostrarGuardadoVeh(panel, vehGuardadoInicial);
    });
  }

  document.addEventListener('click', (event) => {
    const cambiar = event.target.closest('[data-neuma-veh-cambiar]');
    if (!cambiar) return;
    const panel = cambiar.closest('[data-neuma-finder-panel="vehiculo"]');
    const f = vehFields(panel);
    const anterior = leerVehiculo();
    borrarVehiculo();
    f.guardado.hidden = true;
    panel.querySelector('.neuma-fields').hidden = false;
    marcarCompatibles();
    if (!anterior) return;
    asegurarVehPanel(panel).then((indice) => {
      const marca = indice.marcas.find((m) => m.nombre === anterior.marca);
      if (!marca) return;
      f.marca.value = marca.slug;
      return onVehMarcaChange(f.marca).then(() => {
        f.anio.value = anterior.anio;
        if (f.anio.value !== anterior.anio) return;
        return onVehAnioChange(f.anio).then(() => {
          f.modelo.value = anterior.modelo;
          if (f.modelo.value !== anterior.modelo) return;
          return onVehModeloChange(f.modelo).then(() => {
            const i = (vehFilas.get(panel) || []).findIndex((fila) => fila[0] === anterior.version);
            if (i < 0 || f.version.value === String(i)) return;
            f.version.value = String(i);
            onVehVersionChange(f.version);
          });
        });
      });
    }).catch(() => {
      // ver comentario de initVehPanel
    });
  });

  // Insignia "Compatible con tu vehículo" en tarjetas y ficha. El filtrado en
  // vivo reemplaza las tarjetas de la colección, así que además de la pasada
  // inicial se observa el DOM (con debounce, porque el morph reemplaza varios
  // nodos de golpe).
  const marcarCompatibles = () => {
    const veh = leerVehiculo();
    const del = veh ? normalizaMedida(veh.del) : '';
    const tras = veh ? normalizaMedida(veh.tras) : '';
    document.querySelectorAll('[data-neuma-medida]').forEach((el) => {
      const badge = el.querySelector('[data-neuma-compat]');
      if (!badge) return;
      const medida = normalizaMedida(el.dataset.neumaMedida);
      badge.hidden = !(veh && medida !== '' && (medida === del || medida === tras));
    });
  };

  marcarCompatibles();

  let vehObserverTimer = null;
  new MutationObserver(() => {
    clearTimeout(vehObserverTimer);
    vehObserverTimer = setTimeout(marcarCompatibles, 100);
  }).observe(document.body, { childList: true, subtree: true });

  // --- Feedback de envío en los botones de carrito/checkout ----------------
  // Estos forms navegan de página; sin señal el comprador cree que el click no
  // registró y lo repite (dos unidades en el carrito, o doble ida al checkout).
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.neuma-product-form, .neuma-card-form, .neuma-cart-form');
    if (!form) return;
    const button = event.submitter || form.querySelector('button[type="submit"]');
    // ponytail: aria-busy en vez de disabled — deshabilitar el submitter borra
    // su name/value del envío y el form del carrito los usa (update/checkout).
    if (button) button.setAttribute('aria-busy', 'true');
  });

  // Barra de carga mientras el navegador pide la página siguiente. El botón
  // solo avisa en su propio rincón; esto se ve aunque el comprador ya haya
  // scrolleado, y cubre también los enlaces, no solo los forms.
  let barra = null;
  const mostrarBarra = () => {
    if (barra) return;
    barra = document.createElement('div');
    barra.className = 'neuma-progress';
    document.body.appendChild(barra);
    // Si la navegación no llega a ocurrir (un script cancela el envío, el
    // usuario queda en la misma página), la barra no se queda para siempre.
    setTimeout(ocultarBarra, 15000);
  };
  const ocultarBarra = () => {
    barra?.remove();
    barra = null;
  };

  document.addEventListener('submit', (event) => {
    if (!event.defaultPrevented) mostrarBarra();
  });

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    // Solo navegaciones reales de este sitio: nada de anclas, descargas ni pestañas nuevas.
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || /^(javascript|mailto|tel):/i.test(href)) return;
    if (link.origin !== window.location.origin) return;
    if (link.pathname === window.location.pathname && link.search === window.location.search) return;
    mostrarBarra();
  });

  // Al volver con el botón atrás la página sale del bfcache tal como quedó.
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[aria-busy="true"]').forEach((el) => el.removeAttribute('aria-busy'));
    ocultarBarra();
  });
  // Si la navegación se cancela (validación del form, descarga), no dejar la barra colgada.
  window.addEventListener('pagehide', ocultarBarra);
})();
